import { render } from "./Inscription.vue?vue&type=template&id=426ccfd7&scoped=true"
import script from "./Inscription.vue?vue&type=script&lang=js"
export * from "./Inscription.vue?vue&type=script&lang=js"

import "./Inscription.vue?vue&type=style&index=0&id=426ccfd7&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426ccfd7"]])

export default __exports__